import * as yup from "yup";

let productTypeValidationForm = yup.object().shape({
  name: yup.string().required("Name is required"),
});

let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required("Emergency Contact Number is required"),
  vehicle_category: yup.string().required("Vehicle Category is required"),
  vehicle_type: yup.string().required("Vehicle Type is required"),
  license_number: yup.string().required("License Number is required"),
});

export { productTypeValidationForm, vehicleValidationForm };
